import { useThemeSwitcher } from '@/composables/useThemeSwitcher';

export default defineNuxtPlugin(() => {
    const { loadSaved } = useThemeSwitcher();
    loadSaved();
});
